import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Routes to the internal Client Portal hub page.
export const ClientPortalLink = ({ className = "", children, testId = "client-portal-link", showIcon = false }) => (
  <Link to="/client-portal" data-testid={testId} className={className}>
    {children}
    {showIcon && <ArrowUpRight className="ml-1.5 h-4 w-4" aria-hidden="true" />}
  </Link>
);
